import React from 'react';
import {Field} from 'redux-form';

import FormField from 'components/FormField';
import LabelV2 from 'components/LabelV2';
import {DateField} from 'components/Fields';

import {validDate} from 'utils/validators';

import './styles.css';

const RoomPurposeDurationSection = () => (
  <div className="RoomPurposeDurationSection">
    <LabelV2>3.Select Room Purpose Duration</LabelV2>
    <FormField>
      <LabelV2>Start date</LabelV2>
      <Field name="startDate" component={DateField} validate={[validDate]} />
    </FormField>
    <FormField>
      <LabelV2>End date(optional)</LabelV2>
      <Field name="endDate" component={DateField} />
    </FormField>
  </div>
);

export default RoomPurposeDurationSection;
